import * as React from 'react';
import { useRef } from 'react';
import { Button, Spinner } from 'reactstrap';
import { useAppSelector } from '../../hooks/index';
import { Afr, getSelectedAfr } from '../../redux/AfrSlice';
import enums from '../../utils/enums';
import utilityHelper from '../../utils/utilityHelper';
import { AdminUserRoleEnum, selectAdminUserRole } from '../../redux/UserSlice';

export function GenericActionTileUploadFile(props: {
    actionType: string;
    entityName: string,
    entityCode: string,
    afrYear: number,
    tileTitle: string;
    tileDescription: string;
    icon: string;
    isEnabled: boolean;
    uploadedFile: File | null;
    isLoading: boolean;
    clickAction: (atype: string, ename: string, ecode: string, aYear: number, uploadedFile: File ) => void
}) {
    // reference to input type file
    const openFileRef = useRef<any>();
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const adminUserRole: AdminUserRoleEnum | null = useAppSelector(selectAdminUserRole);
    const handleClick = function (event: any) {
        // Open file dialog
        openFileRef.current.click();
    }

    const handleChange = function (event: any) {
        const file: File = event.target.files[0];
        if (!file) { alert("Please select a file.");}
        if (file) {
            // return back to the callere + "]");
            openFileRef.current.value = "";
            props.clickAction(props.actionType, props.entityName, props.entityCode, props.afrYear, file)
        }
            
        
        
    }

    return (
        <div className="my-3">
            <div hidden={props.isLoading == false}>
                <Spinner children={''} style={{ width: '1rem', height: '1rem', marginRight: '1em' }}
                    type="grow" color="warning"
                    hidden={((props.isLoading != null && props.isLoading == false) || props.isLoading == null)} />
                {props.tileDescription}
            </div>
            <div hidden={(props.isLoading != null && props.isLoading == true)}>
                <Button className="mr-3 btn btn-success" disabled={!props.isEnabled || (utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified))
                    || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                    onClick={handleClick}
                ><i className={props.icon}></i>
                </Button>
                {props.tileDescription}
                <input
                    ref={openFileRef}
                    type="file"
                    style={{ display: 'none' }}
                    accept="*.xml"
                    onChange={handleChange}
                />
            </div>
        </div>
    );
}